import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  ContactBannerContainer,
  ContactBannerContent,
  HeadingText,
  ButtonContainer,
  PrimaryButton,
  SecondaryButton,
  BackgroundGraphic,
  VectorImage,
  BannerImage
} from "./styles";

interface ContactBannerProps {
  onDownloadCompanyInfo?: () => void;
}

const ContactBanner: React.FC<ContactBannerProps> = ({
  onDownloadCompanyInfo = () => {
    // Create an anchor element to trigger download
    const link = document.createElement('a');
    link.href = "/document/puzl-company.pdf";
    link.download = "퍼즐코퍼레이션 소개.pdf"; // Set the download filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}) => {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const [isSubmitting, ] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const handleProjectInquiry = () => {
    // Navigate to contact page
    navigate("/contact");
    window.scrollTo(0, 0);
  };

  return (
    <ContactBannerContainer 
      id="contact-banner"
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => !isMobile && setIsHovered(false)}
    >
      <ContactBannerContent>
        <HeadingText>
          PUZL은 장기적으로 함께<br />
          성장할 수 있는 파트너를 찾습니다.
        </HeadingText>
        
        <BannerImage 
          src={isMobile ? "/images/contact/contact-banner-mo.svg" : "/images/contact/contact-banner.svg"}
          alt="PUZL Contact Banner"
        />
        
        <ButtonContainer>
          <PrimaryButton onClick={handleProjectInquiry} disabled={isSubmitting}>
            {isSubmitting ? "처리 중..." : "프로젝트 문의"}
          </PrimaryButton>
          <SecondaryButton onClick={onDownloadCompanyInfo}>
            회사 소개서 다운로드
          </SecondaryButton>
        </ButtonContainer>
      </ContactBannerContent>
      
      {!isMobile && (
        <BackgroundGraphic>
          <VectorImage 
            className="vector-image"
            src="/images/contact/contact-banner.svg"
            opacity={0.5}
            alt=""
            style={{
              transform: isHovered ? 'scale(1.2)' : 'scale(1)',
              transition: 'transform 0.5s ease-in-out'
            }}
          />
        </BackgroundGraphic>
      )}
    </ContactBannerContainer>
  );
};

export default ContactBanner;
